
import { Vue } from "vue-class-component";

export default class DragIndicator extends Vue {}
